// src/components/RouteWithCanonical.tsx
import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import CanonicalLinkPortal from './CanonicalLinkPortal';

const RouteWithCanonical = ({
    path,
    component: Component,
    ...rest
}) => {
    if (!Component) {
        console.error(`RouteWithCanonical for path "${path}" is missing the required 'component' prop.`);
        return null;
    }

    const WrappedComponent = (props) => (
        <>
            {path && <CanonicalLinkPortal href={path} />}
            <Component {...props} />
        </>
    );

    return <Route path={path} render={props => <WrappedComponent {...props} />} {...rest} />;
};

export default RouteWithCanonical;
